import { Box } from '@mui/material';
import type { ReactNode } from 'react';

interface SectionProps {
  children: ReactNode;
}

export function Section({ children }: SectionProps) {
  return (
    <Box sx={{ mb: { xs: 2, md: 3 } }}>
      {children}
    </Box>
  );
}

export default Section;
